export default __webpack_public_path__ + "static/media/oilIcon.ffa5b72e.png";